import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'sal_center_name': {
    title: '营销单元描述'
  },
  'sal_center': {
    title: '营销单元',
    type: 'input',
    equation: all,
    // dictionary: 'sale'
  },
  'sal_base_name': {
    title: '基地描述'
  },
  'sal_base': {
    title: '基地编号',
    type: 'input',
    equation: all,
    // dictionary: 'base'
  },
  'plan_type': {
    title: '计划类型',
    type: 'select',
    equation: cusname,
    dictionary: 'A0002'
  },
  'plan_type_dscr': {
    title: '计划类型描述',
    width: 200
  },
  // 'wlybrand_dscr': {
  //   title: '存货分类名称',
  //   type: 'input',
  //   equation: cusname
  // },
  'wlybrand': {
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  },
  'wlybrand_dscr': {
    title: '存货分类描述'
  },
  'sales_emp_name': {
    title: '业务员',
    type: 'input',
    equation: cusname
  },
  'sales_emp': {
    title: '业务员编号',
    type: 'dialog',
    equation: cusname,
    dialog: {
      component: 'ClientSelect',
      title: '业务员编号'
    }
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'monat': {
    title: '月份',
    type: 'select',
    equation: city,
    dictionary: 'month'
  },
  'plan_qty': {
    title: '预估计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_amt': {
    title: '预估计划额',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealerForecastPlanReportForms.js